import { Document, Page, Text, View, StyleSheet, Font, Image } from '@react-pdf/renderer';

const InvoicePDF = ({ data, month, year, classList, receiptNo, receiptDate, receiptType }) => {
    const pname = data.fullname;

    const totalAmount = data.children.reduce(
        (sum, child) => sum + (receiptType === 'registration' ? Number(child.amount) || 0 : Math.round(child.amount || 0)),
        0
    );
    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <Image source={require('../../images/gradient.png')} style={{ height: 20, width: "150%", position: 'absolute', top: 0 }} />
                <Image source={require('../../images/gradient.png')} style={{ height: 20, width: "150%", position: 'absolute', bottom: 0 }} />
                <View style={{ height: 150 }}>
                    <Text style={{ fontSize: 16, fontFamily: 'Times-Bold', color: "#E56717", marginTop: 30 }}>
                        {receiptType === 'registration' ? 'REGISTRATION RECEIPT' : 'RECEIPT'}
                    </Text>
                    <Text style={{ fontSize: 11, fontFamily: 'Helvetica' }}>PUSAT TUISYEN GENIUS MILENIA</Text>
                    <Text style={{ fontSize: 11, fontFamily: 'Helvetica' }}>NO 1-1 PJCC TAMAN MEDAN, PETALING JAYA</Text>
                    <Text style={{ fontSize: 11, fontFamily: 'Helvetica' }}>03-77732751</Text>
                    <Image source={require('../../images/PTGM-Logo.png')} style={{ height: 100, width: 130, position: 'absolute', right: 30, top: 35 }} />
                    <View style={{ position: 'absolute', right: 30, top: 138 }}>
                        <Text style={{ fontSize: 10, fontFamily: 'Helvetica-Bold' }}>Receipt No: {receiptNo || '-'}</Text>
                        <Text style={{ fontSize: 10, fontFamily: 'Helvetica' }}>Date: {receiptDate || '-'}</Text>
                    </View>
                </View>
                <View style={{ flexDirection: "row", height: 80 }}>
                    <View style={{ flex: 2 }}>
                        <Text style={{ fontSize: 11, fontFamily: 'Helvetica-Bold' }}>ENCIK/PUAN,</Text>
                        <Text style={{ fontSize: 11, fontFamily: 'Helvetica-Bold' }}>{pname ? pname.toUpperCase() : null}</Text>
                    </View>
                </View>
                <View style={{ margin: 20, borderWidth: 1, flexDirection: "row" }}>
                    {/* No */}
                    <View style={{ borderRightWidth: 1, alignItems: 'center', flex: 1, height: 180 }}>
                        <View style={{ borderBottomWidth: 1, width: "100%", alignItems: "center" }}>
                            <Text style={{ fontSize: 11, fontFamily: 'Helvetica-Bold', margin: 3 }}>No</Text>
                        </View>
                        {
                            data.children.map((value, index) => (
                                <Text key={index} style={{ fontSize: 11, fontFamily: 'Helvetica', margin: 3 }}>{index + 1}</Text>
                            ))
                        }
                        <View style={{ borderTopWidth: 1, width: "100%", alignItems: "center", position: "absolute", bottom: 0 }}>
                            <Text style={{ fontSize: 11, fontFamily: 'Helvetica-Bold', margin: 3, color: "white" }}>0</Text>
                        </View>
                    </View>
                    {/* Details */}
                    <View style={{ borderRightWidth: 1, alignItems: 'center', flex: 6, height: 180 }}>
                        <View style={{ borderBottomWidth: 1, width: "100%", alignItems: "center" }}>
                            <Text style={{ fontSize: 11, fontFamily: 'Helvetica-Bold', margin: 3 }}>Details</Text>
                        </View>
                        {
                            receiptType === 'registration'
                                ? data.children.map((value, index) => (
                                    <Text key={index} style={{ fontSize: 11, fontFamily: 'Helvetica', margin: 3 }}>
                                        Registration Fee
                                        {(value.studentNames || (value.fullname ? [value.fullname] : []))
                                            .map((name) => `\n${name}`)
                                            .join('')}
                                    </Text>
                                ))
                                : data.children.map((value, index) => (
                                    <Text key={index} numberOfLines={1} style={{ fontSize: 11, fontFamily: 'Helvetica', margin: 3 }}>
                                        Yuran Bulanan {month} {year} ({classList.find(val => val.batchId === value.class).batchName})
                                    </Text>
                                ))
                        }
                        <View style={{ borderTopWidth: 1, width: "100%", alignItems: "center", position: "absolute", bottom: 0 }}>
                            <Text style={{ fontSize: 11, fontFamily: 'Helvetica-Bold', margin: 3 }}>Total Amount</Text>
                        </View>
                    </View>
                    {/* Quantity */}
                    <View style={{ borderRightWidth: 1, alignItems: 'center', flex: 2, height: 180 }}>
                        <View style={{ borderBottomWidth: 1, width: "100%", alignItems: "center" }}>
                            <Text style={{ fontSize: 11, fontFamily: 'Helvetica-Bold', margin: 3 }}>Quantity</Text>
                        </View>
                        {
                            data.children.map((value, index) => (
                                <Text key={index} style={{ fontSize: 11, fontFamily: 'Helvetica', margin: 3 }}>1</Text>
                            ))
                        }
                        <View style={{ borderTopWidth: 1, width: "100%", alignItems: "center", position: "absolute", bottom: 0 }}>
                            <Text style={{ fontSize: 11, fontFamily: 'Helvetica-Bold', margin: 3, color: "white" }}>0</Text>
                        </View>
                    </View>
                    {/* Unit Price */}
                    <View style={{ borderRightWidth: 1, alignItems: 'center', flex: 2, height: 180 }}>
                        <View style={{ borderBottomWidth: 1, width: "100%", alignItems: "center" }}>
                            <Text style={{ fontSize: 11, fontFamily: 'Helvetica-Bold', margin: 3 }}>Unit Price</Text>
                        </View>
                        {
                            data.children.map((value, index) => (
                                <Text key={index} style={{ fontSize: 11, fontFamily: 'Helvetica', margin: 3 }}>RM{value.amount}</Text>
                            ))
                        }
                        <View style={{ borderTopWidth: 1, width: "100%", alignItems: "center", position: "absolute", bottom: 0 }}>
                            <Text style={{ fontSize: 11, fontFamily: 'Helvetica-Bold', margin: 3, color: "white" }}>0</Text>
                        </View>
                    </View>
                    {/* Amount (RM) */}
                    <View style={{ alignItems: 'center', flex: 2, height: 180 }}>
                        <View style={{ borderBottomWidth: 1, width: "100%", alignItems: "center" }}>
                            <Text style={{ fontSize: 11, fontFamily: 'Helvetica-Bold', margin: 3 }}>Amount (RM)</Text>
                        </View>
                        {
                            data.children.map((value, index) => (
                                <Text key={index} style={{ fontSize: 11, fontFamily: 'Helvetica', margin: 3 }}>RM{value.amount}</Text>
                            ))
                        }
                        <View style={{ borderTopWidth: 1, width: "100%", alignItems: "center", position: "absolute", bottom: 0 }}>
                            <Text style={{ fontSize: 11, fontFamily: 'Helvetica-Bold', margin: 3 }}>RM{totalAmount}</Text>
                        </View>
                    </View>
                </View>
                <View>
                    <Text style={{ fontSize: 11, fontFamily: 'Helvetica', marginTop: 10 }}>Thank you.</Text>
                    <Text style={{ fontSize: 11, fontWeight: "bold", fontFamily: 'Times-Italic', marginTop: 10 }}>‘Excellent Learning Experience’</Text>
                </View>
            </Page>
        </Document>

    )
};

export default InvoicePDF;

Font.register({
    family: 'Open Sans',
    fonts: [
        { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf' },
        { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf', fontWeight: 600 },
        { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf', fontWeight: 600, fontStyle: "italic" }
    ]
});

// Create styles
const styles = StyleSheet.create({
    page: {
        backgroundColor: 'white',
        padding: 20
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1,
    },
});